import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { resetFilter } from '../../actions/environment';
import Top from '../Top/Top';
import ProductList from './ProductList';
import Breadcrumbs from './Breadcrumbs';
import TemplateParser from '../Templates/TemplateParser';
import { origin } from '../../config';
import { prefix } from '../../utils/locale';
import s from './Category.scss';

class Category extends Component {
	render() {
		const { data, currentPath, setup, productCache, filter } = this.props;
		if (!data || !productCache[setup.market] || !productCache[setup.market][setup.pricelist]) return null;
		const parts = data?.parts || [];
		const contentSections = [];
		const bottomSections = [];
		let topSections = 0;

		data.content.linkCanonical = `${origin}${prefix(setup, currentPath)}`;

		parts.forEach((section) => {
			const insertPosition = section.partsMeta.priority || 0;

			// If conflicting parts then take the first version.
			if (parseInt(insertPosition, 10) < 0) {
				if (bottomSections[Math.abs(insertPosition)]) {
					bottomSections[bottomSections.length] = section;
				} else {
					bottomSections[Math.abs(insertPosition)] = section;
				}
			} else if (contentSections[insertPosition]) {
				contentSections[contentSections.length] = section;
			} else {
				contentSections[insertPosition] = section;
			}
		});

		return (
			<main role="main" className={s.category}>
				<Top setup={setup} pageContent={data.content} paths={data.paths} />
				<div className={s.category_topCMS}>
					{
						contentSections.map((section, i) => {
							if (section === undefined || i > topSections) return null;
							topSections += 1;
							return <TemplateParser key={i} sections={section.sections} setup={setup} />;
						})
					}
				</div>
				<Breadcrumbs currentPath={currentPath} filter={filter} filtering={productCache[setup.market][setup.pricelist]} data={data} setup={setup} resetFilter={this.props.resetFilter} category />
				<ProductList filter={filter} filtering={productCache[setup.market][setup.pricelist]} data={data} setup={setup} currentPath={currentPath} contentSections={contentSections.slice(topSections)} />
				<div className={s.category_topCMS}>
					{
						bottomSections.map((section, i) => {
							if (section === undefined) return null;
							return <TemplateParser key={i} sections={section.sections} setup={setup} />;
						})
					}
				</div>
			</main>
		);
	}
}

const mapState = ({ environment, productCache, filter }, { data, currentPath }) => ({
	data,
	currentPath,
	setup: environment.setup,
	productCache,
	filter,
});

export default hot(module)(connect(mapState, { resetFilter })(Category));
